/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganizationUserDto,
  ProblemDetails,
  UpdateOrganizationUserDto,
  UserWithRolesDto,
} from '../models/index';
import {
    CreateOrganizationUserDtoFromJSON,
    CreateOrganizationUserDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateOrganizationUserDtoFromJSON,
    UpdateOrganizationUserDtoToJSON,
    UserWithRolesDtoFromJSON,
    UserWithRolesDtoToJSON,
} from '../models/index';

export interface OrganizationUsersConfirmEmailPUTRequest {
    userId: string;
}

export interface OrganizationUsersCreateOrganizationUserPOSTRequest {
    createOrganizationUserDto?: CreateOrganizationUserDto;
}

export interface OrganizationUsersDeactivateUserDELETERequest {
    userId: string;
}

export interface OrganizationUsersGetUserGETRequest {
    id: string;
}

export interface OrganizationUsersResendConfirmationEmailPUTRequest {
    userId: string;
}

export interface OrganizationUsersUpdateUserPUTRequest {
    userId: string;
    updateOrganizationUserDto?: UpdateOrganizationUserDto;
}

/**
 * OrganizationUsersApi - interface
 * 
 * @export
 * @interface OrganizationUsersApiInterface
 */
export interface OrganizationUsersApiInterface {
    /**
     * Creates request options for organizationUsersConfirmEmailPUT without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersConfirmEmailPUTRequestOpts(requestParameters: OrganizationUsersConfirmEmailPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersConfirmEmailPUTRaw(requestParameters: OrganizationUsersConfirmEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersConfirmEmailPUT(requestParameters: OrganizationUsersConfirmEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for organizationUsersCreateOrganizationUserPOST without sending the request
     * @param {CreateOrganizationUserDto} [createOrganizationUserDto] 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersCreateOrganizationUserPOSTRequestOpts(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateOrganizationUserDto} [createOrganizationUserDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersCreateOrganizationUserPOSTRaw(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersCreateOrganizationUserPOST(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for organizationUsersDeactivateUserDELETE without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersDeactivateUserDELETERequestOpts(requestParameters: OrganizationUsersDeactivateUserDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersDeactivateUserDELETERaw(requestParameters: OrganizationUsersDeactivateUserDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersDeactivateUserDELETE(requestParameters: OrganizationUsersDeactivateUserDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for organizationUsersGetOrganizationUsersGET without sending the request
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersGetOrganizationUsersGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersGetOrganizationUsersGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserWithRolesDto>>>;

    /**
     */
    organizationUsersGetOrganizationUsersGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserWithRolesDto>>;

    /**
     * Creates request options for organizationUsersGetUserGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersGetUserGETRequestOpts(requestParameters: OrganizationUsersGetUserGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersGetUserGETRaw(requestParameters: OrganizationUsersGetUserGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersGetUserGET(requestParameters: OrganizationUsersGetUserGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for organizationUsersResendConfirmationEmailPUT without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersResendConfirmationEmailPUTRequestOpts(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersResendConfirmationEmailPUTRaw(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersResendConfirmationEmailPUT(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

    /**
     * Creates request options for organizationUsersUpdateUserPUT without sending the request
     * @param {string} userId 
     * @param {UpdateOrganizationUserDto} [updateOrganizationUserDto] 
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersUpdateUserPUTRequestOpts(requestParameters: OrganizationUsersUpdateUserPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {UpdateOrganizationUserDto} [updateOrganizationUserDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUsersApiInterface
     */
    organizationUsersUpdateUserPUTRaw(requestParameters: OrganizationUsersUpdateUserPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>>;

    /**
     */
    organizationUsersUpdateUserPUT(requestParameters: OrganizationUsersUpdateUserPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto>;

}

/**
 * 
 */
export class OrganizationUsersApi extends runtime.BaseAPI implements OrganizationUsersApiInterface {

    /**
     * Creates request options for organizationUsersConfirmEmailPUT without sending the request
     */
    async organizationUsersConfirmEmailPUTRequestOpts(requestParameters: OrganizationUsersConfirmEmailPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUsersConfirmEmailPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationUsers/{userId}/confirm-email`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationUsersConfirmEmailPUTRaw(requestParameters: OrganizationUsersConfirmEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersConfirmEmailPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersConfirmEmailPUT(requestParameters: OrganizationUsersConfirmEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersConfirmEmailPUTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersCreateOrganizationUserPOST without sending the request
     */
    async organizationUsersCreateOrganizationUserPOSTRequestOpts(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/OrganizationUsers`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationUserDtoToJSON(requestParameters['createOrganizationUserDto']),
        };
    }

    /**
     */
    async organizationUsersCreateOrganizationUserPOSTRaw(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersCreateOrganizationUserPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersCreateOrganizationUserPOST(requestParameters: OrganizationUsersCreateOrganizationUserPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersCreateOrganizationUserPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersDeactivateUserDELETE without sending the request
     */
    async organizationUsersDeactivateUserDELETERequestOpts(requestParameters: OrganizationUsersDeactivateUserDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUsersDeactivateUserDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationUsers/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationUsersDeactivateUserDELETERaw(requestParameters: OrganizationUsersDeactivateUserDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersDeactivateUserDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersDeactivateUserDELETE(requestParameters: OrganizationUsersDeactivateUserDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersDeactivateUserDELETERaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersGetOrganizationUsersGET without sending the request
     */
    async organizationUsersGetOrganizationUsersGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationUsers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationUsersGetOrganizationUsersGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserWithRolesDto>>> {
        const requestOptions = await this.organizationUsersGetOrganizationUsersGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserWithRolesDtoFromJSON));
    }

    /**
     */
    async organizationUsersGetOrganizationUsersGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserWithRolesDto>> {
        const response = await this.organizationUsersGetOrganizationUsersGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersGetUserGET without sending the request
     */
    async organizationUsersGetUserGETRequestOpts(requestParameters: OrganizationUsersGetUserGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationUsersGetUserGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationUsers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationUsersGetUserGETRaw(requestParameters: OrganizationUsersGetUserGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersGetUserGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersGetUserGET(requestParameters: OrganizationUsersGetUserGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersGetUserGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersResendConfirmationEmailPUT without sending the request
     */
    async organizationUsersResendConfirmationEmailPUTRequestOpts(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUsersResendConfirmationEmailPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/OrganizationUsers/{userId}/resend-confirmation-email`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organizationUsersResendConfirmationEmailPUTRaw(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersResendConfirmationEmailPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersResendConfirmationEmailPUT(requestParameters: OrganizationUsersResendConfirmationEmailPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersResendConfirmationEmailPUTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for organizationUsersUpdateUserPUT without sending the request
     */
    async organizationUsersUpdateUserPUTRequestOpts(requestParameters: OrganizationUsersUpdateUserPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling organizationUsersUpdateUserPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/OrganizationUsers/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationUserDtoToJSON(requestParameters['updateOrganizationUserDto']),
        };
    }

    /**
     */
    async organizationUsersUpdateUserPUTRaw(requestParameters: OrganizationUsersUpdateUserPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserWithRolesDto>> {
        const requestOptions = await this.organizationUsersUpdateUserPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserWithRolesDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationUsersUpdateUserPUT(requestParameters: OrganizationUsersUpdateUserPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserWithRolesDto> {
        const response = await this.organizationUsersUpdateUserPUTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
